import { message } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';

import {
  finishedFetchingCurrencyRate,
  startFetchingCurrencyRate,
} from './actions/CurrencyRateAction';
import Page404 from './components/ErrorPage/Page404';
import { getAllowedURLS } from './components/Layout/DashboardLayout';
import withDashboard from './components/Layout/withDashboard';
import withExternalDashboard from './components/Layout/withExternalDashboard';
import Loadable from './components/Loadable';
import {
  URL_AGING_REPORT,
  URL_API_KEYS,
  URL_API_KEY_ANALYTICS,
  URL_PERMISSION_GROUPS,
  URL_AMAZON_ORDERS,
  URL_ANALYTICS,
  URL_ANALYTICS_ACTIVITY_TRACKING,
  URL_ANALYTICS_WORLD_MAPS,
  URL_ASYNC_TASK_REPORT,
  URL_BILLING_PARTIES,
  URL_BLACKLIST_KEYWORDS,
  URL_CONTRACT_LIST,
  URL_CRON_TRIGGERS,
  URL_NOTIFICATIONS,
  URL_CREATE_SUPPLIER_PAYMENT,
  URL_CREATE_SUPPLIER_VENDOR,
  URL_CREATE_SUPPLIER_VENDOR_RESULT,
  URL_CUSTOMER_SOA,
  URL_CUSTOMER_SOA_CONSOLIDATED_LIST,
  URL_CUSTOMER_SOA_DETAIL,
  URL_DELETE_PRODUCT,
  URL_EMAIL_READER_ORDER_FROM_MAIL,
  URL_EXCHANGE_RATE_SETTINGS,
  URL_ENTITY,
  URL_EXTERNAL_GRN_RATING,
  URL_GENERAL_CONFIRMATION_PAGE,
  URL_GMV_ANALYTICS,
  URL_GOODS_DELIVERY,
  URL_GRN_RATING_LIST,
  URL_HOME,
  URL_JD_INTEGRATION,
  URL_JD_INVOICE,
  URL_LINE_ITEM_ANALYTIC,
  URL_MARGIN_ANOMALY_REVIEW,
  URL_QTY_CHECK_REVIEW,
  URL_ORDER_INVOICE_DETAIL,
  URL_ORDER_INVOICE_LOGS,
  URL_ORDER_INVOICE_PUBLIC,
  URL_BUYER_INVOICING,
  URL_MONTHLY_ANALYTICS,
  URL_OCI,
  URL_ORDER_ITEMS_CATEGORIES,
  URL_OUTBOUND_EMAILS,
  URL_OVERVIEW,
  URL_PAYMENT_METHODS,
  URL_PETER_NCPR_MARKETPLACE,
  URL_PO,
  URL_PO_V2,
  URL_PRODUCT,
  URL_PRODUCT_CODE,
  URL_PRODUCT_EXTERNAL,
  URL_PRODUCT_EXTERNAL_CREATE_SUCCESS,
  URL_PRODUCT_MARKETPLACE,
  URL_QUICK_CRAWL,
  URL_QUOTATIONS,
  URL_REGION_CONFIG,
  URL_REGIONAL_TAX,
  URL_RESOURCE,
  URL_RESOURCE_STORE,
  URL_REVERT_SUPPLIER_PAYMENT_STATUS,
  URL_RFQ,
  URL_RFQ_TO_SUPPLIER,
  URL_S2P_PERSONAL_DASHBOARD,
  URL_SETTINGS,
  URL_SME_MARKETPLACE,
  URL_SOA_PAYMENTS,
  URL_SUPPLIER_PAYMENTS,
  URL_SUPPLIER_PAYMENTS_CREATE,
  URL_SUPPLIER_PAYMENTS_DETAILS,
  URL_SUPPLIER_PAYMENTS_GRAPHS,
  URL_SUPPLIER_PAYMENTS_V2,
  URL_SUPPLIER_SOA,
  URL_SUPPLIER_SOA_DETAIL,
  URL_SUPPLIER_SOA_OUTSTANDING_PAYMENT,
  URL_SUPPLIER_SOA_VCARD,
  URL_SUPPLIER_QUICK_SOA,
  URL_SUPPLIER_SOA_VCARD_DETAIL,
  URL_SUPPLIER_UPDATE_DELIVERY_DATE,
  URL_SUPPLIERS,
  URL_SUPPLIERS_PENDING,
  URL_VENDOR_QUESTIONS,
  URL_SYNC_99SME,
  URL_TICKETING_LIST,
  URL_TICKETING_LIST_EXTERNAL,
  URL_TICKETING_SUBMIT,
  URL_TRACKING_ANALYTICS,
  URL_UPLOAD,
  URL_USER_SETTING,
  URL_USERS,
  URL_XERO_OAUTH2_CALLBACK,
  URL_XERO_SETTINGS,
  URL_XERO_SYNC_MAPPING,
} from './constants/URLS';
import QuotationsList from './containers/Quotations/QuotationsList';
import DeleteProduct from './containers/Settings/DeleteProduct';
import { fetchAPI } from './utils/api';
import { loginRequired, notLoginRedirect } from './utils/route';

const AuthenticatePage = Loadable(
  React.lazy(() => import('./containers/Authentication/AuthenticatePage'))
);
const ProductListing = Loadable(
  React.lazy(() => import('./containers/Product/ProductListing'))
);
const ProductExternalCreate = Loadable(
  React.lazy(() => import('./containers/Product/ProductExternalCreate'))
);
const ProductExternalCreateSuccess = Loadable(
  React.lazy(() => import('./containers/Product/ProductExternalCreateSuccess'))
);
const ProductResource = Loadable(
  React.lazy(() => import('./containers/Product/ProductResource'))
);
const ProductStore = Loadable(
  React.lazy(() => import('./containers/Product/ProductStore'))
);
const SettingPage = Loadable(
  React.lazy(() => import('./containers/Settings/SettingPage'))
);
const ExchangeRateSettingLazy = Loadable(
  React.lazy(() => import('./containers/Settings/ExchangeRateCRUD'))
);
const CronTriggerPage = Loadable(
  React.lazy(() => import('./containers/Settings/CronTriggerPage'))
);
const NotificationListLazy = Loadable(
  React.lazy(() => import('./containers/Notification/NotificationList'))
);
const OrderListing = Loadable(
  React.lazy(() => import('./containers/Order/OrderListing'))
);
const OrderListingV2 = Loadable(
  React.lazy(() => import('./containers/Order/OrderListV2/OrderListingV2'))
);
const AsyncTaskReportListing = Loadable(
  React.lazy(() => import('./containers/AsyncTaskReport/TaskListing'))
);
// const QuotationsList = Loadable(
//   React.lazy(() => import('./containers/Quotations/QuotationsList'))
// );
const RfqListing = Loadable(
  React.lazy(() => import('./containers/RFQ/RFQListing'))
);
const RfqToSupplierListing = Loadable(
  React.lazy(() => import('./containers/RFQToSupplier/RFQToSupplierListing'))
);
const ProductCodeListing = Loadable(
  React.lazy(() => import('./containers/ProductCode/ProductCodeListing'))
);
const ProductOverview = Loadable(
  React.lazy(() => import('./containers/Product/ProductOverview'))
);
const Anlytics = Loadable(
  React.lazy(() => import('./containers/Analytics/Analytics'))
);

const OCIPage = Loadable(React.lazy(() => import('./containers/OCI/OCIPage')));
const QuickCrawlPage = Loadable(
  React.lazy(() => import('./containers/QuickCrawl/QuickCrawlPage'))
);
const UserPage = Loadable(
  React.lazy(() => import('./containers/User/UserListing'))
);
const BatchUpload = Loadable(
  React.lazy(() => import('./containers/BatchUpload/BatchUpload'))
);
// const CardRequestPage = Loadable(
//   React.lazy(() => import('./containers/CardRequest/CardRequestListing'))
// );
const EntityListing = Loadable(
  React.lazy(() => import('./containers/Entity/EntityListing'))
);
const SupplierDirectory = Loadable(
  React.lazy(() => import('./containers/Suppliers/SupplierDirectoryPage'))
);

const SupplierSoaLazy = Loadable(
  React.lazy(() => import('./containers/Suppliers/Soa/SoaPage'))
);

const CustomerSoaLazy = Loadable(
  React.lazy(() => import('./containers/Entity/Soa/CustomerSoaList'))
);

const SupplierSoaDetailLazy = Loadable(
  React.lazy(() => import('./containers/Suppliers/Soa/SupplierSOADetail'))
);
const CustomerSoaDetailLazy = Loadable(
  React.lazy(() => import('./containers/Entity/Soa/EntitySOADetail'))
);
const CustomerSoAConsolidatedList = Loadable(
  React.lazy(() => import('./containers/Entity/Soa/ConsolidatedEntitySoAList'))
);
const SupplierSoaVcardDetail = Loadable(
  React.lazy(() => import('./containers/Suppliers/Soa/SupplierSoaVcardDetail'))
);

const SupplierPaymentsLazy = Loadable(
  React.lazy(() => import('./containers/SupplierPayments/SupplierPaymentsList'))
);

const SupplierPaymentsV2Lazy = Loadable(
  React.lazy(() =>
    import('./containers/SupplierPayments/v2/SupplierPaymentListV2')
  )
);

const SupplierPaymentCreatePageLazy = Loadable(
  React.lazy(() =>
    import('./containers/SupplierPayments/SupplierPaymentCreatePage')
  )
);

const SOAPaymentsLazy = Loadable(
  React.lazy(() => import('./containers/SOAPayments/SOAPaymentsList'))
);
const PaymentMethodsLazy = Loadable(
  React.lazy(() => import('./containers/PaymentMethods/PaymentMethods'))
);

const SupplierDetailsLazy = Loadable(
  React.lazy(() =>
    import(
      './containers/SupplierPayments/SupplierPaymentDetails/SupplierPaymentDetails'
    )
  )
);

const SupplierPaymentGraphsLazy = Loadable(
  React.lazy(() =>
    import(
      './containers/SupplierPayments/SupplierPaymentGraphs/SupplierPaymentGraphs'
    )
  )
);

const LineItemAnalyticLazy = Loadable(
  React.lazy(() =>
    import(
      './containers/SupplierPayments/SupplierPaymentGraphs/LineItemAnalyticPage'
    )
  )
);

const XeroSettingsPageLazy = Loadable(
  React.lazy(() => import('./containers/Xero/XeroSettingsPage'))
);
const XeroOAuthCallbackPageLazy = Loadable(
  React.lazy(() => import('./containers/Xero/XeroOAuthCallbackPage'))
);

const SyncTo99mse = Loadable(
  React.lazy(() => import('./containers/SyncTo99Sme/SyncTo99smePage'))
);

const JDIntegrationPage = Loadable(
  React.lazy(() => import('./containers/JDIntegration/JDIntegrationPage'))
);

const CreateSupplierPaymentExternal = Loadable(
  React.lazy(() =>
    import(
      './containers/SupplierPayments/SupplierPaymentExternal/SupplierPaymentExternalCreate'
    )
  )
);

const CreatePendingSupplier = Loadable(
  React.lazy(() =>
    import('./containers/Suppliers/PendingSupplier/CreatePendingSupplier')
  )
);

const CreatePendingSupplierResult = Loadable(
  React.lazy(() =>
    import('./containers/Suppliers/PendingSupplier/CreatePendingSupplierResult')
  )
);

const BillingPartyList = Loadable(
  React.lazy(() => import('./containers/BillingParties/BillingPartyList'))
);

const RevertSPIDStatusLazy = Loadable(
  React.lazy(() =>
    import('./containers/SupplierPaymentsRevert/RevertSupplierPaymentStatus')
  )
);

const SubmitTicketLazy = Loadable(
  React.lazy(() => import('./containers/Ticketing/SubmitTicket'))
);

const TicketingPageLazy = Loadable(
  React.lazy(() => import('./containers/Ticketing/TicketingPage'))
);

const SubmittedTicketListExternalLazy = Loadable(
  React.lazy(() => import('./containers/Ticketing/SubmittedTicketListExternal'))
);

const SubmitRateOrderLazy = Loadable(
  React.lazy(() => import('./containers/GRN/SubmitRateOrder'))
);

const GRNRateListLazy = Loadable(
  React.lazy(() => import('./containers/GRN/GRNRateList'))
);

const AmazonOrdersLazy = Loadable(
  React.lazy(() => import('./containers/AmazonOrders/AmazonOrderList'))
);

const GoodDeliveryPageLazy = Loadable(
  React.lazy(() => import('./containers/GoodsDelivery/GoodsDeliveryPage'))
);

const SupplierChangeDeliveryDateLazy = Loadable(
  React.lazy(() =>
    import('./containers/SupplierChangeDeliveryDate/SupplierChangeDeliveryDate')
  )
);

const ProductMarketplaceListingLazy = Loadable(
  React.lazy(() =>
    import('./containers/ProductMarketplace/ProductMarketplaceListing')
  )
);

const ContractListLazy = Loadable(
  React.lazy(() => import('./containers/ContractList/ContractList'))
);

const S2PPersonalDashboardLazy = Loadable(
  React.lazy(() =>
    import('./containers/S2PPersonalDashboard/S2PPersonalDashboard')
  )
);

const SMEMarketplaceLazy = Loadable(
  React.lazy(() => import('./containers/SMEMarketplace/SMEMarketplace'))
);

const GeneralConfirmationPageLazy = Loadable(
  React.lazy(() =>
    import('./containers/GeneralConfirmationPage/GeneralConfirmationPage')
  )
);

const PeterNCPRMarketplaceListLazy = Loadable(
  React.lazy(() =>
    import('./containers/PeterNCPRMarketplace/PeterNCPRMarketplaceList')
  )
);

const OutboundEmailListLazy = Loadable(
  React.lazy(() => import('./containers/OutboundEmails/OutboundEmailList'))
);

const EmailReaderOrderFromMailLazy = Loadable(
  React.lazy(() => import('./containers/EmailReader/OrderFromMailList'))
);

const APIKeyPageLazy = Loadable(
  React.lazy(() => import('./containers/Settings/APIKeyPage'))
);

const APIAnalyticPageLazy = Loadable(
  React.lazy(() => import('./containers/Settings/APIAnalyticPage'))
);

const PermissionGroupPageLazy = Loadable(
  React.lazy(() => import('./containers/Settings/PermissionGroupPage'))
);

const MarginAnomalyReviewLazy = Loadable(
  React.lazy(() => import('./containers/SupplierPayments/MarginAnomalyReview'))
);

const QtyCheckReviewLazy = Loadable(
  React.lazy(() => import('./containers/Orders/QtyCheckReview'))
);

const OrderInvoiceLogsLazy = Loadable(
  React.lazy(() => import('./containers/Order/OrderInvoiceLogs'))
);
const OrderInvoiceDetailLazy = Loadable(
  React.lazy(() => import('./containers/Order/OrderInvoiceDetail'))
);
const BuyerInvoicingLazy = Loadable(
  React.lazy(() => import('./containers/Order/BuyerInvoicing'))
);

const OrderInvoicePublicLazy = Loadable(
  React.lazy(() => import('./containers/Order/OrderInvoicePublic'))
);

const App = () => {
  const currencyRate = useSelector((state: any) => state.currency);
  const user = useSelector((state: any) => state.user);
  const dispatch = useDispatch();
  const allowedURLs = getAllowedURLS(user.role, user.team);
  const homeUrl = allowedURLs.includes(URL_TICKETING_LIST)
    ? URL_TICKETING_LIST
    : URL_PRODUCT;

  const getCurrencyRates = async () => {
    if (!user?.id || currencyRate.loading || currencyRate.fetched) {
      return;
    }

    dispatch(startFetchingCurrencyRate());
    try {
      const resp = await fetchAPI(`exchange-rates/latest`);
      dispatch(finishedFetchingCurrencyRate(resp?.rate || {}));
    } catch (error) {
      message.error('Failed get currency exchange rates');
    }
  };

  useEffect(() => {
    getCurrencyRates();
  }, [user?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <React.Fragment>
      <Switch>
        <Route exact path="/" render={() => <Redirect to={homeUrl} />} />
        <Route
          exact
          path={URL_CREATE_SUPPLIER_PAYMENT}
          component={CreateSupplierPaymentExternal}
        />
        <Route
          exact
          path={URL_CREATE_SUPPLIER_VENDOR}
          component={CreatePendingSupplier}
        />
        <Route
          exact
          path={URL_CREATE_SUPPLIER_VENDOR_RESULT}
          component={CreatePendingSupplierResult}
        />

        <Route
          exact
          path="/login"
          component={notLoginRedirect(AuthenticatePage)}
        />

        <Route exact path="/forget-verify" component={AuthenticatePage} />
        <Route
          exact
          path={URL_OVERVIEW}
          component={loginRequired(withDashboard(ProductOverview))}
        />
        <Route
          exact
          path={URL_ANALYTICS}
          component={loginRequired(withDashboard(Anlytics))}
        />
        <Route
          exact
          path={URL_MONTHLY_ANALYTICS}
          component={loginRequired(withDashboard(Anlytics))}
        />
        <Route
          exact
          path={URL_GMV_ANALYTICS}
          component={loginRequired(withDashboard(Anlytics))}
        />
        <Route
          exact
          path={URL_TRACKING_ANALYTICS}
          component={loginRequired(withDashboard(Anlytics))}
        />
        <Route
          exact
          path={URL_AGING_REPORT}
          component={loginRequired(withDashboard(Anlytics))}
        />
        <Route
          exact
          path={URL_ANALYTICS_WORLD_MAPS}
          component={loginRequired(withDashboard(Anlytics))}
        />
        <Route
          exact
          path={URL_ANALYTICS_ACTIVITY_TRACKING}
          component={loginRequired(withDashboard(Anlytics))}
        />

        <Route
          exact
          path={URL_HOME}
          component={loginRequired(withDashboard(TicketingPageLazy))}
        />
        <Route
          exact
          path={URL_PRODUCT}
          component={loginRequired(withDashboard(ProductListing))}
        />
        <Route
          exact
          path={URL_PRODUCT_EXTERNAL}
          component={withExternalDashboard(ProductExternalCreate)}
        />
        <Route
          exact
          path={URL_PRODUCT_EXTERNAL_CREATE_SUCCESS}
          component={withExternalDashboard(ProductExternalCreateSuccess)}
        />
        <Route
          exact
          path={URL_RESOURCE}
          component={loginRequired(withDashboard(ProductResource))}
        />
        <Route
          exact
          path={URL_SETTINGS}
          component={loginRequired(withDashboard(SettingPage))}
        />
        <Route
          exact
          path={URL_BLACKLIST_KEYWORDS}
          component={loginRequired(withDashboard(SettingPage))}
        />
        <Route
          exact
          path={URL_REGIONAL_TAX}
          component={loginRequired(withDashboard(SettingPage))}
        />
        <Route
          exact
          path={URL_REGION_CONFIG}
          component={loginRequired(withDashboard(SettingPage))}
        />
        <Route
          exact
          path={URL_EXCHANGE_RATE_SETTINGS}
          component={loginRequired(withDashboard(ExchangeRateSettingLazy))}
        />
        <Route
          exact
          path={URL_ORDER_ITEMS_CATEGORIES}
          component={loginRequired(withDashboard(SettingPage))}
        />
        <Route
          exact
          path={URL_QUOTATIONS}
          component={loginRequired(withDashboard(QuotationsList))}
        />
        <Route
          exact
          path={URL_RFQ}
          component={loginRequired(withDashboard(RfqListing))}
        />
        <Route
          exact
          path={URL_RFQ_TO_SUPPLIER}
          component={loginRequired(withDashboard(RfqToSupplierListing))}
        />
        <Route
          exact
          path={URL_ASYNC_TASK_REPORT}
          component={loginRequired(withDashboard(AsyncTaskReportListing))}
        />
        <Route
          exact
          path={URL_PO}
          component={loginRequired(withDashboard(OrderListing))}
        />
        <Route
          exact
          path={URL_PO_V2}
          component={loginRequired(withDashboard(OrderListingV2))}
        />
        <Route
          exact
          path={URL_ENTITY}
          component={loginRequired(withDashboard(EntityListing))}
        />
        <Route
          exact
          path={URL_SUPPLIERS}
          component={loginRequired(withDashboard(SupplierDirectory))}
        />
        <Route
          exact
          path={URL_SUPPLIER_SOA}
          component={loginRequired(withDashboard(SupplierSoaLazy))}
        />
        <Route
          exact
          path={URL_SUPPLIER_SOA_OUTSTANDING_PAYMENT}
          component={loginRequired(withDashboard(SupplierSoaLazy))}
        />
        <Route
          exact
          path={URL_CUSTOMER_SOA}
          component={loginRequired(withDashboard(CustomerSoaLazy))}
        />
        <Route
          exact
          path={URL_SUPPLIER_SOA_DETAIL}
          component={loginRequired(withDashboard(SupplierSoaDetailLazy))}
        />
        <Route
          exact
          path={URL_CUSTOMER_SOA_DETAIL}
          component={loginRequired(withDashboard(CustomerSoaDetailLazy))}
        />
        <Route
          exact
          path={URL_CUSTOMER_SOA_CONSOLIDATED_LIST}
          component={loginRequired(withDashboard(CustomerSoAConsolidatedList))}
        />
        <Route
          exact
          path={URL_SUPPLIER_SOA_VCARD}
          component={loginRequired(withDashboard(SupplierSoaLazy))}
        />
        <Route
          exact
          path={URL_SUPPLIER_QUICK_SOA}
          component={loginRequired(withDashboard(SupplierSoaLazy))}
        />
        <Route
          exact
          path={URL_SUPPLIER_SOA_VCARD_DETAIL}
          component={loginRequired(withDashboard(SupplierSoaVcardDetail))}
        />
        <Route
          exact
          path={URL_SUPPLIERS_PENDING}
          component={loginRequired(withDashboard(SupplierDirectory))}
        />
        <Route
          exact
          path={URL_VENDOR_QUESTIONS}
          component={loginRequired(withDashboard(SupplierDirectory))}
        />
        <Route
          exact
          path={URL_SUPPLIER_PAYMENTS}
          component={loginRequired(withDashboard(SupplierPaymentsLazy))}
        />
        <Route
          exact
          path={URL_PAYMENT_METHODS}
          component={loginRequired(withDashboard(PaymentMethodsLazy))}
        />
        <Route
          exact
          path={URL_SUPPLIER_PAYMENTS_CREATE}
          component={loginRequired(
            withDashboard(SupplierPaymentCreatePageLazy)
          )}
        />
        <Route
          exact
          path={URL_REVERT_SUPPLIER_PAYMENT_STATUS}
          component={loginRequired(withDashboard(RevertSPIDStatusLazy))}
        />
        <Route
          exact
          path={URL_SUPPLIER_PAYMENTS_V2}
          component={loginRequired(withDashboard(SupplierPaymentsV2Lazy))}
        />
        <Route
          exact
          path={URL_SOA_PAYMENTS}
          component={loginRequired(withDashboard(SOAPaymentsLazy))}
        />
        <Route
          exact
          path={URL_SUPPLIER_PAYMENTS_GRAPHS}
          component={loginRequired(withDashboard(SupplierPaymentGraphsLazy))}
        />
        <Route
          exact
          path={URL_LINE_ITEM_ANALYTIC}
          component={loginRequired(withDashboard(LineItemAnalyticLazy))}
        />
        <Route
          exact
          path={URL_SUPPLIER_PAYMENTS_DETAILS}
          component={loginRequired(withDashboard(SupplierDetailsLazy))}
        />
        <Route
          exact
          path={URL_MARGIN_ANOMALY_REVIEW}
          component={loginRequired(withDashboard(MarginAnomalyReviewLazy))}
        />
        <Route
          exact
          path={URL_QTY_CHECK_REVIEW}
          component={loginRequired(withDashboard(QtyCheckReviewLazy))}
        />
        <Route
          exact
          path={URL_XERO_SETTINGS}
          component={loginRequired(withDashboard(XeroSettingsPageLazy))}
        />
        <Route
          exact
          path={URL_XERO_SYNC_MAPPING}
          component={loginRequired(withDashboard(XeroSettingsPageLazy))}
        />
        <Route
          exact
          path={URL_XERO_OAUTH2_CALLBACK}
          component={loginRequired(withDashboard(XeroOAuthCallbackPageLazy))}
        />
        <Route
          exact
          path={URL_BILLING_PARTIES}
          component={loginRequired(withDashboard(BillingPartyList))}
        />
        <Route
          exact
          path={URL_PRODUCT_CODE}
          component={loginRequired(withDashboard(ProductCodeListing))}
        />

        <Route
          exact
          path={URL_OCI}
          component={loginRequired(withDashboard(OCIPage))}
        />

        <Route
          exact
          path={URL_QUICK_CRAWL}
          component={loginRequired(withDashboard(QuickCrawlPage))}
        />
        <Route
          exact
          path={URL_USERS}
          component={loginRequired(withDashboard(UserPage))}
        />
        <Route
          exact
          path={URL_UPLOAD}
          component={loginRequired(withDashboard(BatchUpload))}
        />
        <Route
          exact
          path={URL_RESOURCE_STORE}
          component={loginRequired(withDashboard(ProductStore))}
        />
        <Route
          exact
          path={URL_SYNC_99SME}
          component={loginRequired(withDashboard(SyncTo99mse))}
        />
        <Route
          exact
          path={URL_JD_INTEGRATION}
          component={loginRequired(withDashboard(JDIntegrationPage))}
        />
        <Route
          exact
          path={URL_JD_INVOICE}
          component={loginRequired(withDashboard(JDIntegrationPage))}
        />
        <Route
          exact
          path={URL_USER_SETTING}
          component={loginRequired(withDashboard(SettingPage))}
        />
        <Route
          exact
          path={URL_DELETE_PRODUCT}
          component={loginRequired(withDashboard(DeleteProduct))}
        />
        <Route exact path={URL_TICKETING_SUBMIT} component={SubmitTicketLazy} />
        <Route
          exact
          path={URL_TICKETING_LIST}
          component={loginRequired(withDashboard(TicketingPageLazy))}
        />
        <Route
          exact
          path={URL_TICKETING_LIST_EXTERNAL}
          component={SubmittedTicketListExternalLazy}
        />
        <Route
          exact
          path={URL_EXTERNAL_GRN_RATING}
          component={SubmitRateOrderLazy}
        />
        <Route
          exact
          path={URL_GRN_RATING_LIST}
          component={loginRequired(withDashboard(GRNRateListLazy))}
        />
        <Route
          exact
          path={URL_AMAZON_ORDERS}
          component={loginRequired(withDashboard(AmazonOrdersLazy))}
        />
        <Route
          exact
          path={URL_GOODS_DELIVERY}
          component={loginRequired(withDashboard(GoodDeliveryPageLazy))}
        />
        <Route
          exact
          path={URL_SUPPLIER_UPDATE_DELIVERY_DATE}
          component={SupplierChangeDeliveryDateLazy}
        />
        {/* <Route
            exact
            path={URL_CARD_REQUEST}
            component={loginRequired(withDashboard(CardRequestPage))}
          /> */}
        <Route
          exact
          path={URL_PRODUCT_MARKETPLACE}
          component={loginRequired(
            withDashboard(ProductMarketplaceListingLazy)
          )}
        />
        <Route
          exact
          path={URL_CONTRACT_LIST}
          component={loginRequired(withDashboard(ContractListLazy))}
        />
        <Route
          exact
          path={URL_S2P_PERSONAL_DASHBOARD}
          component={loginRequired(withDashboard(S2PPersonalDashboardLazy))}
        />
        <Route
          exact
          path={URL_SME_MARKETPLACE}
          component={loginRequired(withDashboard(SMEMarketplaceLazy))}
        />
        <Route
          exact
          path={URL_GENERAL_CONFIRMATION_PAGE}
          component={GeneralConfirmationPageLazy}
        />
        <Route
          exact
          path={URL_PETER_NCPR_MARKETPLACE}
          component={loginRequired(withDashboard(PeterNCPRMarketplaceListLazy))}
        />
        <Route
          exact
          path={URL_OUTBOUND_EMAILS}
          component={loginRequired(withDashboard(OutboundEmailListLazy))}
        />
        <Route
          exact
          path={URL_EMAIL_READER_ORDER_FROM_MAIL}
          component={loginRequired(withDashboard(EmailReaderOrderFromMailLazy))}
        />
        <Route
          exact
          path={URL_API_KEYS}
          component={loginRequired(withDashboard(APIKeyPageLazy))}
        />
        <Route
          exact
          path={URL_API_KEY_ANALYTICS}
          component={loginRequired(withDashboard(APIAnalyticPageLazy))}
        />
        <Route
          exact
          path={URL_ORDER_INVOICE_LOGS}
          component={loginRequired(withDashboard(OrderInvoiceLogsLazy))}
        />
        <Route
          exact
          path={URL_ORDER_INVOICE_DETAIL}
          component={loginRequired(withDashboard(OrderInvoiceDetailLazy))}
        />
        <Route
          exact
          path={URL_ORDER_INVOICE_PUBLIC}
          component={OrderInvoicePublicLazy}
        />
        <Route
          exact
          path={URL_BUYER_INVOICING}
          component={loginRequired(withDashboard(BuyerInvoicingLazy))}
        />
        <Route
          exact
          path={URL_PERMISSION_GROUPS}
          component={loginRequired(withDashboard(PermissionGroupPageLazy))}
        />
        <Route
          exact
          path={URL_NOTIFICATIONS}
          component={loginRequired(withDashboard(NotificationListLazy))}
        />
        <Route
          exact
          path={URL_CRON_TRIGGERS}
          component={loginRequired(withDashboard(CronTriggerPage))}
        />
        <Route component={Page404} />
      </Switch>
    </React.Fragment>
  );
};

export default App;
